import * as React from 'react'
import { animateScroll } from 'react-scroll'

import { MergedProps as Props } from '../../containers/welcome'
import HeaderComponent from '../common/headerComponent'
import FooterComponent from '../common/footerComponent'
import ServiceComponent from './components/serviceComponent'
import WorksComponent from './components/worksComponent'
import OutClinentsComponent from './components/outClientsComponent'
import CompanyComponent from './components/companyComponent'
import ContactComponent from '../common/contactComponent'

interface State {
	isShowBackTop: boolean
}

export default class WelcomeComponent extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props)

		this.state = {
			isShowBackTop: false
		}

		this.onScroll = this.onScroll.bind(this)
	}

	componentDidMount() {
		window.addEventListener('scroll', (e) => this.onScroll())
	}

	onScroll() {
		const currentScrollPoint = window.pageYOffset
		if (currentScrollPoint > 635) {
			this.setState({
				isShowBackTop: true
			})
		} else {
			this.setState({
				isShowBackTop: false
			})
		}
	}

	onPageTop() {
		animateScroll.scrollToTop()
	}

	render() {
		const pageTopHidden = {
			display: 'none'
		}
		return (
			<div>
				<div className="wrap">
					<HeaderComponent
						title="テクノロジーで、世界をデザインしていく。"
						description="We design the world through technology."
						isTopPage={true}
					/>
					<div className="wrapper">
						<div className="row">
							<div className="container-fluid">
								<ServiceComponent />
								<WorksComponent />
								<OutClinentsComponent />
								<CompanyComponent />
								<ContactComponent />
							</div>
						</div>
					</div>
					<FooterComponent isTopPage={true} />
					<div id="pageTop" style={this.state.isShowBackTop ? {} : pageTopHidden}>
						<a
							onClick={() => this.onPageTop()}
						>
							<img src="img/btn_page_top.png" alt="GENESIS" />
						</a>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/welcome/index.tsx